<template>
  <div class="ml-5 mr-5 pb-4">
    <b-row class="mt-4">
      <b-col align-self="center">
        <h4>Überstundenregelung für Arbeitnehmende im Stundenlohn</h4>
        <hr>
      </b-col>
    </b-row>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <u-loader v-if="isLoading" />
    <div v-else>
      <!-- Header Row -->
      <b-row class="mt-5">
        <b-col
          class="col_1"
          cols="auto"
        />
        <b-col :cols="col_2_len">
          <h6>Modalität/Lösung</h6>
        </b-col>
        <b-col :cols="col_3_len">
          <h6>Bemerkung (Wo und seit wann publiziert)</h6>
        </b-col>
      </b-row>
      <hr class="custom_hr2">

      <!-- ROW 1 - Abbrechnung nach Einsatzes -->
      <b-row>
        <b-col
          class="pr-0 pt-0"
          cols="auto"
        >
          <v-checkbox
            v-model="checkbox_abbrechnungNachEinsatz"
            :disabled="!canUserEdit"
            class="pt-2"
            color="#e72b37"
            @change="setSelectedCheckbox('checkbox_abbrechnungNachEinsatz')"
          />
        </b-col>
        <b-col :cols="col_2_len">
          <p class="body-1 customText">
            Abrechnung nach <u>Bedingung des Einsatzes</u> durch Vergleich der
            Ist- und Soll-Zeit
          </p>
        </b-col>
        <b-col :cols="col_3_len">
          <v-textarea
            v-model="textinput_abbrechnungNachEinsatz"
            :background-color="
              checkbox_abbrechnungNachEinsatz ? '#FFFFFF' : '#FAF9F6'
            "
            :disabled="
              checkbox_abbrechnungNachEinsatz && canUserEdit ? false : true
            "
            class="custom_textarea body-1"
            rows="3"
          />
        </b-col>
      </b-row>
      <hr>
      <!-- ROW 2 - Wöchentliche Abbrechnung -->
      <b-row>
        <b-col
          class="pr-0 pt-0"
          cols="auto"
        >
          <v-checkbox
            v-model="checkbox_abbrechnungWoechentlich"
            :disabled="!canUserEdit"
            class="pt-2"
            color="#e72b37"
            @change="setSelectedCheckbox('checkbox_abbrechnungWoechentlich')"
          />
        </b-col>
        <b-col :cols="col_2_len">
          <p class="body-1 customText">
            <u>Wöchentliche</u> Abrechnung durch Vergleich der Ist- und
            Soll-Zeit(Wochenzeitsaldo)
          </p>
        </b-col>
        <b-col :cols="col_3_len">
          <v-textarea
            v-model="textinput_abbrechnungWoechentlich"
            :background-color="
              checkbox_abbrechnungWoechentlich ? '#FFFFFF' : '#FAF9F6'
            "
            :disabled="
              checkbox_abbrechnungWoechentlich && canUserEdit ? false : true
            "
            class="custom_textarea body-1"
            rows="3"
          />
        </b-col>
      </b-row>
      <hr>

      <!-- ROW 3 - Andere Abbrechnung -->
      <b-row>
        <b-col
          class="pr-0 pt-0"
          cols="auto"
        >
          <v-checkbox
            v-model="checkbox_abbrechnungAndere"
            :disabled="!canUserEdit"
            class="pt-2"
            color="#e72b37"
            @change="setSelectedCheckbox('checkbox_abbrechnungAndere')"
          />
        </b-col>
        <b-col :cols="col_2_len">
          <p class="body-1 customText">
            anderer Lösungsansatz/ anderer Abrechnungszeitraum, welcher?
          </p>
        </b-col>
        <b-col :cols="col_3_len">
          <v-textarea
            v-model="textinput_abbrechnungAndere"
            :background-color="
              checkbox_abbrechnungAndere ? '#FFFFFF' : '#FAF9F6'
            "
            :disabled="checkbox_abbrechnungAndere && canUserEdit ? false : true"
            class="custom_textarea body-1"
            rows="3"
          />
        </b-col>
      </b-row>
      <hr>

      <!-- ROW 4 - Abbrechnung Offen -->
      <b-row>
        <b-col
          class="pr-0 pt-0"
          cols="auto"
        >
          <v-checkbox
            v-model="checkbox_abbrechnungOffen"
            :disabled="!canUserEdit"
            class="pt-2"
            color="#e72b37"
            @change="setSelectedCheckbox('checkbox_abbrechnungOffen')"
          />
        </b-col>
        <b-col :cols="col_2_len">
          <p class="body-1 customText">
            Noch kein Lösungsansatz/ keine aktuelle Auslegung
          </p>
        </b-col>
        <b-col :cols="col_3_len">
          <v-textarea
            v-model="textinput_abbrechnungOffen"
            :background-color="
              checkbox_abbrechnungOffen ? '#FFFFFF' : '#FAF9F6'
            "
            :disabled="checkbox_abbrechnungOffen && canUserEdit ? false : true"
            class="custom_textarea body-1"
            rows="3"
          />
        </b-col>
      </b-row>
      <hr class="custom_hr">

      <b-row
        align-h="end"
        class="pt-0 mt-5 pr-5 mr-3"
      >
        <b-col cols="auto">
          <v-btn
            v-if="canUserEdit"
            color="success"
            tile
            @click="saveOvertimeItems"
          >
            <i class="fas fa-save pr-2" />
            Speichern
          </v-btn>
        </b-col>
        <b-col cols="auto">
          <v-btn
            v-if="canUserEdit"
            color="#e72b37"
            style="color: white"
            tile
            @click="resetOvertimesItem"
          >
            <i class="fas fa-ban pr-2" />
            Abbrechen
          </v-btn>
        </b-col>
        <b-col cols="1" />
      </b-row>
    </div>
  </div>
</template>

<script>
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";
import { SaveWageSuppConf } from "@/services/minimum.wage.services/zuschlagsrechner/worktime";

export default {
  mixins: [MinimumWageMixin],
  props: {
    wageSupplementConfiguration: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isLoading: true,
      errorObject: null,
      col_2_len: 4,
      col_3_len: 6,

      checkbox_abbrechnungNachEinsatz: false,
      checkbox_abbrechnungWoechentlich: false,
      checkbox_abbrechnungAndere: false,
      checkbox_abbrechnungOffen: false,

      textinput_abbrechnungNachEinsatz: "",
      textinput_abbrechnungWoechentlich: "",
      textinput_abbrechnungAndere: "",
      textinput_abbrechnungOffen: "",

      orginalOvertimeObject: null,
    };
  },
  created() {
    this.setWorkitemsFields();
  },
  methods: {
    setSelectedCheckbox(checkbox) {
      if (checkbox !== "checkbox_abbrechnungNachEinsatz") {
        this.checkbox_abbrechnungNachEinsatz = false;
      }
      if (checkbox !== "checkbox_abbrechnungWoechentlich") {
        this.checkbox_abbrechnungWoechentlich = false;
      }
      if (checkbox !== "checkbox_abbrechnungAndere") {
        this.checkbox_abbrechnungAndere = false;
      }
      if (checkbox !== "checkbox_abbrechnungOffen") {
        this.checkbox_abbrechnungOffen = false;
      }
    },
    saveOvertimeItems() {
      this.isLoading = true;
      SaveWageSuppConf(
        this.contractId,
        this.versionId,
        this.editionId,
        this.editionId,
        this.getOvertimeObject(),
        () => {
          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    //Setz alle Werte im Frontend, mit den Werten vom Backend
    setWorkitemsFields() {
      if (this.wageSupplementConfiguration) {
        if (
          this.wageSupplementConfiguration
            .overtimeRegulation_BillingOtherDefinition
        ) {
          this.checkbox_abbrechnungAndere =
            this.wageSupplementConfiguration.overtimeRegulation_BillingOtherDefinition.isActive;
          this.textinput_abbrechnungAndere =
            this.wageSupplementConfiguration.overtimeRegulation_BillingOtherDefinition.remark;
        }

        if (
          this.wageSupplementConfiguration
            .overtimeRegulation_BillingAccordingDeployment
        ) {
          this.checkbox_abbrechnungNachEinsatz =
            this.wageSupplementConfiguration.overtimeRegulation_BillingAccordingDeployment.isActive;
          this.textinput_abbrechnungNachEinsatz =
            this.wageSupplementConfiguration.overtimeRegulation_BillingAccordingDeployment.remark;
        }

        if (this.wageSupplementConfiguration.overtimeRegulation_BillingWeekly) {
          this.checkbox_abbrechnungWoechentlich =
            this.wageSupplementConfiguration.overtimeRegulation_BillingWeekly.isActive;
          this.textinput_abbrechnungWoechentlich =
            this.wageSupplementConfiguration.overtimeRegulation_BillingWeekly.remark;
        }

        if (this.wageSupplementConfiguration.overtimeRegulation_BillingNotSet) {
          this.checkbox_abbrechnungOffen =
            this.wageSupplementConfiguration.overtimeRegulation_BillingNotSet.isActive;
          this.textinput_abbrechnungOffen =
            this.wageSupplementConfiguration.overtimeRegulation_BillingNotSet.remark;
        }
      }
      this.isLoading = false;
    },

    resetOvertimesItem() {
      this.isLoading = true;
      this.setWorkitemsFields(this.orginalOvertimeObject);
    },

    //Erstellt das Objekt gemäss Backend, für die Speicherung der Daten
    getOvertimeObject() {
      if (this.wageSupplementConfiguration) {
        if (
          this.wageSupplementConfiguration
            .overtimeRegulation_BillingAccordingDeployment
        ) {
          this.wageSupplementConfiguration.overtimeRegulation_BillingAccordingDeployment.isActive =
            this.checkbox_abbrechnungNachEinsatz;
          this.wageSupplementConfiguration.overtimeRegulation_BillingAccordingDeployment.remark =
            this.textinput_abbrechnungNachEinsatz;
        }

        if (this.wageSupplementConfiguration.overtimeRegulation_BillingWeekly) {
          this.wageSupplementConfiguration.overtimeRegulation_BillingWeekly.isActive =
            this.checkbox_abbrechnungWoechentlich;
          this.wageSupplementConfiguration.overtimeRegulation_BillingWeekly.remark =
            this.textinput_abbrechnungWoechentlich;
        }

        if (
          this.wageSupplementConfiguration
            .overtimeRegulation_BillingOtherDefinition
        ) {
          this.wageSupplementConfiguration.overtimeRegulation_BillingOtherDefinition.isActive =
            this.checkbox_abbrechnungAndere;
          this.wageSupplementConfiguration.overtimeRegulation_BillingOtherDefinition.remark =
            this.textinput_abbrechnungAndere;
        }

        if (this.wageSupplementConfiguration.overtimeRegulation_BillingNotSet) {
          this.wageSupplementConfiguration.overtimeRegulation_BillingNotSet.isActive =
            this.checkbox_abbrechnungOffen;
          this.wageSupplementConfiguration.overtimeRegulation_BillingNotSet.remark =
            this.textinput_abbrechnungOffen;
        }
      }
      return this.wageSupplementConfiguration;
    },
  },
};
</script>

<style>
.col_1 {
  width: 48px;
}

.customText {
  padding: 23px 0 0 0;
}

.custom_textarea textarea {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  padding-left: 10px;
  border-radius: 5px;
}
</style>
